import React from 'react';

import { ApiService, Urls } from 'js/src/client';
import { AuthQueryParams } from 'js/src/components/auth/auth-consts';
import { Toast } from 'js/src/components/common/Toast';
import Button, { BUTTON_SIZES } from 'js/src/components/common/ui/Button';

type Props = {
    signupEmail?: string;
    inviteId?: string;
};

const SSOSignupForm = React.memo(function SSOSignupForm({
    signupEmail = '',
    inviteId = '',
}: Props) {
    const handleUserSignUp = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        ApiService.ssoVerficationCreate({
            body: { email: signupEmail.toLowerCase(), invite_uuid: inviteId },
        })
            .then((response) => {
                const idp = response.data.idp;
                if (idp) {
                    window.location.href =
                        Urls.SSO_AUTH +
                        `?${AuthQueryParams.NEXT}=` +
                        encodeURIComponent(window.location.pathname + window.location.search) +
                        `&${AuthQueryParams.IDP}=` +
                        idp;
                }
            })
            .catch(() => {
                Toast.error('Oops, something went wrong');
            });
    };

    return (
        <div className="form-sidebar">
            <h4>Sign up to accept the invitation.</h4>
            <br />
            <div className="mb-l5-16">
                <Button
                    onClick={handleUserSignUp}
                    text="Sign up with SSO"
                    iconLeft="key"
                    size={BUTTON_SIZES.LG}
                    className="w-100"
                    disabled={!signupEmail}
                />
            </div>
        </div>
    );
});

export default SSOSignupForm;
